"use strict";
/*import { debounce } from "debounce";*/
import 'whatwg-fetch'; // IE10 Polyfill

export function initInScope ($scope) {

    let $large =  $scope.find('.js-product-detail-slider__large');

    if($large.length >= 1){
        import('slick-carousel').then(() =>{

            let swipe = true;
            if($large.find('a').first().find('.js-threeSixty').length > 0){
                swipe = false;
            }

            $large.on('afterChange', () => {
                setOptions();
            });

            $large.slick({
                dots: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<button type="button" class="btn-no-styling slick-prev slider__arrow" aria-label="Previous"><span class="icon icon-arrow-left" aria-hidden="true"></span></button>',
                nextArrow: '<button type="button" class="btn-no-styling slick-next slider__arrow" aria-label="Next"><span class="icon icon-arrow-right" aria-hidden="true"></span></button>',
                infinite: false,
                swipe: swipe
            });

            function setOptions() {
                let $currentSlide = $large.find('.slick-slide.slick-current.slick-active');
                if($currentSlide.find('.js-threeSixty').length > 0){

                    /* preload 360 images */
                    $large.slick('slickSetOption', "swipe", false);
                    let slickurl = $currentSlide.find('.js-threeSixty').attr('data-preload-url');
                    let $loading = $currentSlide.find('.js-threeSixty__loading');
                    let pendingRequest;
                    pendingRequest = fetch(slickurl, {
                        method: 'GET',
                        headers: {
                            'X-Requested-With' : 'XMLHttpRequest',
                            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                        }
                    }).then((res) => {
                        return res.json()
                    }).then((res) => {
                        pendingRequest = null;
                        if (res.success) {
                            let imagesArray = res.images;
                            const images = imagesArray;

                            Promise.all(images.map((src) => {
                                return new Promise((resolve, reject) => {
                                    const image = new Image();

                                    image.onload = resolve;
                                    image.onerror = resolve;

                                    image.style.display = 'none';
                                    image.src = src;

                                    document.body.appendChild(image);
                                })
                            }))

                            import('@mladenilic/threesixty.js').then((ThreeSixty) =>{
                                $loading.attr('hidden', true);
                                ThreeSixty = ThreeSixty.default;

                                const threesixty = new ThreeSixty(document.getElementById('js-threeSixty'), {
                                    image: images,
                                    inverted: true,
                                    width: $('.js-product-detail-slider__large').width(),
                                    height: $('.js-product-detail-slider__large .slick-track').height(),
                                    dragTolerance: 20,  // Rotation speed when dragging. Default: 10
                                    swipeTolerance: 20, // Rotation speed when swiping. Default: 10
                                });

                                $currentSlide.one('mousedown touchstart', function () {
                                    $('.js-threeSixty__info').attr('hidden', true);
                                });

                                // change cursor on mousedown
                                $currentSlide.on('mousedown', function (evt) {
                                    $(this).addClass('mousedown')
                                }).on('mouseup', function () {
                                    $(this).removeClass('mousedown');
                                });

                            });
                        }
                    });
                }else{
                    $large.slick('slickSetOption', "swipe", true)
                }
            }

            let $goToThreeSixty = $('.js-go-to-threeSixty');
            $goToThreeSixty.on('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                $large.slick('slickGoTo', $large.find('.slick-slide').length -1);
            });

            let $openLightbox = $('.js-open-lightbox');
            $openLightbox.on('click', (e) => {
                $large.find('.slick-slide.slick-current.slick-active .js-lightbox__item').trigger('click');
            });
        });
    }



    let $containerElements = $scope.find('.js-product-detail-color-slider-container');
    if ($containerElements.length >= 1) {
        import('slick-carousel').then(() => {
            initColorSlider();

            //$(window).on('resize', debounce(initColorSlider, 200));
            window.addEventListener("orientationchange", function() {
                initColorSlider();
            }, false);
        });
    }

    function initColorSlider() {
        let isMobile = matchMedia('(max-width: 767px)').matches;
        let slideWidth = isMobile ? 70 : 80;

        $containerElements.each(function () {
            let $container = $(this);
            let $colorSlider = $container.find('.js-product-detail-color-slider');
            $container.css({
                'width': '',
            });

            if ($colorSlider.hasClass('slick-initialized')) {
                $colorSlider.slick('unslick');
            }

            let activeSlideIndex = $colorSlider.find('.active').index();

            let containerWidth = $container.width();
            let maxWidth = containerWidth - containerWidth % slideWidth;
            let slideCount = $colorSlider.children().length;
            let slidesToShow = Math.min(Math.floor(maxWidth / slideWidth), slideCount);
            let width = slidesToShow * slideWidth;
            $container.css({
                'width': width,
                'max-width': '100%',
            });

            $colorSlider.slick({
                dots: true,
                speed: 300,
                slidesToShow: slidesToShow,
                swipeToSlide: true,
                slidesToScroll: slidesToShow,
                prevArrow: '<button type="button" class="btn-no-styling slick-prev slider__arrow" aria-label="Previous"><span class="icon icon-arrow-left" aria-hidden="true"></span></button>',
                nextArrow: '<button type="button" class="btn-no-styling slick-next slider__arrow" aria-label="Next"><span class="icon icon-arrow-right" aria-hidden="true"></span></button>',
                infinite: false
            });

            $colorSlider.slick('slickGoTo', Math.min(
                Math.floor(activeSlideIndex / slidesToShow) * slidesToShow,
                slideCount - slidesToShow
            ));
        });
    }
}